// extracted by css-extract-rspack-plugin
export default {"cls1":"SocialProofUniversityFooter-cls1_VFG","cls2":"SocialProofUniversityFooter-cls2_LH2 SocialProofUniversityFooter-cls1_VFG"};